module.exports = __webpack_public_path__ + "static/img/weixin-android.d6d97df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/comment/weixin-android.png
// module id = ZXI2
// module chunks = 11